module.exports = __webpack_public_path__ + "img/diaText.0581688c.png";